import React from "react";
import ServicePage from "./ServicePage";

export default function MarketingPage() {
  return (
    <ServicePage
      number="03"
      eyebrow="Serviciu digital"
      title={["Marketing."]}
      tagline="Soluții de marketing eficiente pentru dezvoltarea afacerii tale — bazate pe date, gândite editorial, executate integrat."
      intro={[
        "Pe o piață în care concurența este tot mai acerbă, adoptarea unor strategii de marketing inovatoare devine esențială pentru creșterea și consolidarea unei afaceri.",
        "Dezvoltăm soluții strategice bazate pe analize riguroase, pentru a identifica nevoile specifice ale brandului într-un peisaj de piață dinamic. Implementăm tactici de marketing digital de ultimă generație pentru maximizarea vizibilității și a impactului.",
        "Angajamentul nostru este să generăm creștere sustenabilă și avantaj competitiv prin campanii eficiente și colaborări media strategice.",
      ]}
      stepsEyebrow="Transformăm viziunea în succes"
      stepsTitle="Strategie · Plan · Acțiuni."
      steps={[
        { title: "Strategie", desc: "Definim obiectivele ce trebuie îndeplinite și direcția generală de comunicare." },
        { title: "Plan", desc: "Detaliem cum le atingem — tactici, canale, calendar și indicatori clari de performanță." },
        { title: "Acțiuni", desc: "Transformăm planul în realitate cu execuție integrată online și offline." },
      ]}
      servicesEyebrow="Servicii de marketing"
      servicesTitle="Șapte direcții pentru un brand în creștere."
      services={[
        {
          title: "Strategie & plan de marketing",
          tags: "Cercetare de piață · branding · poziționare · planificare campanie · analiză performanță · marketing mix.",
          desc: "Strategia conturează direcția, iar planul indică fiecare pas către obiective. Modelul nostru în șase etape oferă o abordare cuprinzătoare pentru planificarea și executarea strategiilor de marketing.",
          list: [
            "Analiza situației curente.",
            "Definirea obiectivelor.",
            "Dezvoltarea strategiei pentru atingerea obiectivelor.",
            "Stabilirea tacticilor și acțiunilor.",
            "Întocmirea planului de acțiuni și a calendarului.",
            "Monitorizarea și evaluarea performanței.",
          ],
        },
        {
          title: "Manual de brand",
          tags: "Identitate vizuală · ghid stil · logo · norme utilizare · paletă cromatică · tipografie · ton de voce.",
          desc: "Brand-book-ul definește toate aspectele identității audio-vizuale — de la logo și culori la tipografie și ton. Este punctul de referință pentru toți specialiștii implicați în comunicarea brandului și menține o imagine puternică, ușor de recunoscut.",
        },
        {
          title: "Conținut foto, video & audio",
          tags: "Fotografii · producție video · copywriting · storytelling · spoturi publicitare audio.",
          desc: [
            "Fotografiile de calitate și producțiile video dau viață mesajelor brandului, iar copywriting-ul și storytelling-ul transformă conceptele în povești captivante.",
            "Spoturile audio transmit informații ascultătorilor de radio sau utilizatorilor platformelor online. Toate materialele sunt create conform regulilor din manualul de brand.",
          ],
        },
        {
          title: "Conținut text",
          tags: "Copywriting · storytelling · redactare editorială · texte publicitare · texte website · articole blog · social media.",
          desc: "Copywriting și storytelling transmit valorile, personalitatea și mesajele cheie ale afacerii. Textele sunt elaborate de specialiști cu peste 20 de ani de experiență în comunicare consistentă și de impact.",
        },
        {
          title: "Buletin informativ / Newsletter",
          tags: "Newsletter lunar / săptămânal · raport de activitate · revistă online · broșură.",
          desc: "Newsletter-ul, revista sau broșura online mențin o legătură continuă cu publicul-țintă. Furnizează direct pe e-mail informații relevante, noutăți, oferte speciale ori invitații la evenimente — consolidează relația cu clienții.",
        },
        {
          title: "Articole PR",
          tags: "Comunicate de presă · advertoriale · comunicare proiecte europene.",
          desc: "Articolele de relații publice promovează branduri, companii sau evenimente în presă și în spațiul public. Distribuite către publicații, site-uri de știri și alte canale, contribuie la construirea și menținerea unei imagini favorabile.",
        },
        {
          title: "Publicitate online & offline",
          tags: "Campanii digitale · reclame tipărite · panouri publicitare · pliante · broșuri · spoturi TV & radio.",
          desc: [
            "Publicitatea online se concentrează pe promovarea prin site-uri, rețele sociale, motoare de căutare și e-mail marketing — oferă flexibilitate și date detaliate despre performanță.",
            "Publicitatea offline (TV, radio, print, outdoor, evenimente) atinge un public mai mare. Ambele au un rol bine definit în funcție de obiective și publicul țintă.",
          ],
        },
      ]}
    />
  );
}
